<template>
  <!-- 吸底, 自己的一列 -->
  <q-section v-bind="$attrs" :bg-i="mineRank.bg">
    <q-section v-for="(item, index) in [mineRank]" wh="100%" p="relative" :key="`mine-${index}`">
      <q-section
        :bg-i="item?.user?.avatar_url"
        v-bind="item?.avatarPosition"
        @click="handleAvatarClick(item?.user_id || 0)"></q-section>
      <q-section wh="126 40" pc="y" pl="102" class="flex flex-col justify-center">
        <q-section v-bind="item.nicknamePosition" p="relative" class="text-nowrap ellipsis">
          {{ item.user?.nickname }}
        </q-section>
        <q-section v-bind="item.unitPosition" p="relative" class="text-nowrap">
          {{ item.unit }}{{ item[item.scoreType] }}
        </q-section>
      </q-section>
      <q-section v-bind="item.rankPosition" class="flex flex-row justify-center items-center">
        {{ item.isInRank ? item.rank : '-' }}
      </q-section>
      <q-section
        :bg-i="item.mineBtnBg"
        :key="`mine-btn-${item.mineBtnBg}`"
        v-bind="item.mineBtnPosition"
        @click="handleClick({})"></q-section>
    </q-section>
  </q-section>
</template>

<script setup lang="ts">
const props = defineProps<{
  mineRank: any
}>()

const emit = defineEmits<{
  (e: 'avatarClick', userId: number): void
  (e: 'click', data: any): void
}>()

const handleAvatarClick = (userId: number) => {
  emit('avatarClick', userId)
}

const handleClick = (data: any) => {
  emit('click', data)
}
</script>

<style scoped lang="scss">
.ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
